function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#596168",
  fillRule: "evenodd",
  d: "M6.236.018a.594.594 0 01.739.576v.54h3.003a1 1 0 011.001 1v3a.667.667 0 01-1.335 0V2.467H6.998v11.066h2.647v-2.662a.667.667 0 011.334 0v2.995a1 1 0 01-1 1H6.974v.54a.594.594 0 01-.739.576L.758 14.69A1 1 0 010 13.72V2.281a1 1 0 01.758-.97L6.236.018zm2.405 7.318h3.34V5.674a.343.343 0 01.54-.273l3.317 2.33a.332.332 0 010 .547l-3.316 2.33a.343.343 0 01-.541-.272V8.67H8.64a.667.667 0 010-1.334z"
});

var SvgLogout = function SvgLogout(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default SvgLogout;